var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"my-account-button btn btn-primary p-3",attrs:{"href":_vm.url}},[_c('img',{staticClass:"my-account-button__icon",attrs:{"src":require("@/static/images/icons/cavp.svg"),"width":"18","height":"18","alt":""}}),_vm._v(" Mon compte personnel ")])
}
var staticRenderFns = []

export { render, staticRenderFns }